import { useContext, useEffect, useState } from "react";
import * as _btn_ from "@Elementos/Boton";
import * as _div_ from "@Elementos/Div";
import * as _f_ from "@Funciones/funciones";
import ModalInformacion from "@ModalInformacion/ModalInformacion";

import { Contexto } from "@Componentes/App";

import "./ProcesandoAccion.css";
export const ProcesandoAccion = ({
  origen,
  texto,
  accion,
  
}) => {
  const { ecv_u, cv_u, usuarioSesion, esComputadora } = useContext(Contexto);

  const [v_u, ev_u] = useState({
    d_exito: false,
    i_procesandoApi: false,
  });

  useEffect(()=>{
    console.log("entre")
    accion?.();
  },[])

  return (
    <>
      <_div_.Div texto={texto} />

      <div className="procesandoAccionCSS-cuerpo">
        <div className="procesando-barras" aria-label="Procesando">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>

        <div className="procesando-texto">
          Procesando<span className="procesando-puntos"></span>
        </div>
      </div>
    </>
  );
};
